<template>
  <div class="templates">
    <CustomTable title="Поставщики" :rowsData="this.rowsData" :columns="this.providersColumns" :loading="isFetching"
      :show-search="true" :custom-body="true" :sticky-header="true" :showHeaderAdd="true"
      :on-add-click="this.handleAddClick">
      <template #customBody="props">
        <q-tr>
          <CustomTableCell align="center">
            {{ props.row.provider_id }}
          </CustomTableCell>
          <CustomTableCell align="left">
            <Clickable @click="() => this.handleUpdateClick(props.row)">
              {{ props.row.provider_name }}
            </Clickable>
            <span v-if="props.row.is_show_old_price">
              <br>
              <em>(Показывать цену без скидки)</em>
            </span>
            <span v-else>
            </span>
            <br>
            <span style="font-style: italic; font-size: 11px" v-if="props.row.director_fio">ФИО директора: <span
                v-html="props.row.director_fio"></span></span>

            <div v-if="props.row.sbs_partner_id" style="margin-top: 8px;">
              Поставщик SBS:
              <span class="providers-page__sbs-title">
                {{
                  props.row.sbs_partner_name }}</span>
            </div>
          </CustomTableCell>

          <CustomTableCell align="left" style="min-width: 300px;">
            <div class="providers-page__tax-info">
              <div v-if="props.row.snr_naimenovanie" class="providers-page__tax-item">
                <div class="providers-page__tax-label">
                  <span>СНР</span>
                </div>
                <div class="providers-page__tax-value" v-html="props.row.snr_naimenovanie"></div>
                <div class="providers-page__tax-guid" v-if="props.row.guid_snr_for_onec">
                  GUID: {{ props.row.guid_snr_for_onec }}
                </div>
              </div>
              <div v-if="props.row.oked_naimenovanie" class="providers-page__tax-item">
                <div class="providers-page__tax-label">
                  <span>ОКЭД</span>
                </div>
                <div class="providers-page__tax-value" v-html="props.row.display_name"></div>
                <div class="providers-page__tax-guid" v-if="props.row.guid_oked_for_onec">
                  GUID: {{ props.row.guid_oked_for_onec }}
                </div>
              </div>
            </div>
          </CustomTableCell>

          <CustomTableCell align="center" vertical-align="center">
            <div class="params-block">
              <div class="param-item">
                <span class="param-label">Запрет на создание автоматических платежей:</span>
                <CheckOrClose :value="props.row.is_not_create_auto_payment" />
              </div>
              <div class="param-item highlight">
                <span class="param-label">Маржа материала:</span>
                <span class="param-value">{{ props.row.material_marzha }}</span>
              </div>
              <div class="param-item">
                <span class="param-label">Плательщик НДС:</span>
                <CheckOrClose :value="props.row.is_nds" />
              </div>
              <div class="param-item">
                <span class="param-label">Отправка заявок:</span>
                <CheckOrClose :value="props.row.is_auto_gpr" />
              </div>
              <div class="param-item">
                <span class="param-label">Подписка на рассылку:</span>
                <CheckOrClose :value="props.row.is_subscribe" />
              </div>
            </div>
          </CustomTableCell>

          <!-- <CustomTableCell align="left" title="Документы">
            <BlockItem>
              <CustomDropdown :onClick="this.handleClickDoc" :options="props.row.documents?.reports" title="Выгрузка" />
            </BlockItem>
          </CustomTableCell> -->

          <CustomTableCell align="center">
            <span v-html="props.row.city_name"></span>
          </CustomTableCell>

          <CustomTableCell align="left">
            <div class="info">
              <div class="details">
                <div v-if="props.row.address"><strong>Адрес:</strong> {{ props.row.address }}</div>
                <div v-if="props.row.phone"><strong>Телефон:</strong> {{ props.row.phone }}</div>
                <div v-if="props.row.provider_email"><strong>Email:</strong> {{ props.row.provider_email }}</div>
              </div>
            </div>
          </CustomTableCell>

          <CustomTableCell align="left">
            <div class="info">
              <div class="name">{{ props.row.bank_name }}</div>
              <div class="details">
                <div v-if="props.row.iik"><strong>ИИК:</strong> {{ props.row.iik }}</div>
                <div v-if="props.row.kbe"><strong>КБЕ:</strong> {{ props.row.kbe }}</div>
                <div v-if="props.row.bin"><strong>БИН:</strong> {{ props.row.bin }}</div>
              </div>
            </div>
          </CustomTableCell>

          <CustomTableCell align="left">
            {{ props.row.comment }}
          </CustomTableCell>

          <CustomTableCell align="center">
            <span v-if="props.row.is_send_to_1c_text === 'Отправлен в 1С'">
              {{ props.row.is_send_to_1c_text }}
              <br>
              <CheckOrClose :value="props.row.is_send_to_1c" />
            </span>
            <span v-else>
              {{ props.row.is_send_to_1c_text }} <br>
            </span>
            <q-btn v-if="props.row.is_send_to_1c === 0" :loading="btnLoading[props.row.provider_id]"
              @click="sendTo1CHandler(props.row.provider_id)" color="primary" size="sm"
              label="Отправить в 1С" dense />
            <span v-if="props.row.guid">
              <br>
              GUID: {{ props.row.guid }}
              <q-tooltip>guid</q-tooltip>
            </span>
          </CustomTableCell>

          <CustomTableCell align="center" vertical-align="center">
            <div style="gap: 16px; display: flex; flex-direction: column;">
              <CustomIcon @click="() => this.handleUpdateClick(props.row)" icon="edit" />
              <CustomIcon icon="trash" :approve-mode="true" :loading="this.loading"
                :approve="() => this.onDeleteSubmit(props.row.provider_id)" />
            </div>
          </CustomTableCell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import BlockItem from "@/components/common/BlockItem";
import CustomDropdown from "@/components/common/CustomDropdown";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomIcon from "@/components/common/CustomIcon";
import Clickable from "@/components/common/Clickable";
import {
  getHandbookProviders,
  addHandbookProvider,
  providersColumns,
  updateHandbookProvider,
  deleteHandbookProvider,
  sendTo1C
} from "@/views/Providers/services";
import CheckOrClose from "@/components/common/CheckOrClose";
import { useAppStore } from "@/services/store/app";
import { MODAL_NAMES } from "@/constants";

export default {
  name: "HandbookProviders",
  components: { CheckOrClose, Clickable, CustomIcon, CustomTableCell, CustomTable, CustomDropdown, BlockItem },
  data() {
    return {
      providersColumns,
      rowsData: [],
      isFetching: false,
      loading: false,
      btnLoading: {},
    }
  },
  methods: {
    async getData() {
      this.isFetching = true
      const res = await getHandbookProviders()
      this.isFetching = false
      if (!res) return
      this.rowsData = res
    },
    async handleAddClick() {
      this.showModal(MODAL_NAMES.Add_HANDBOOK_PROVIDER, {
        onSubmit: this.onAddSubmit,
        title: 'Добавить поставщика'
      });
    },
    async handleUpdateClick(row) {
      this.showModal(MODAL_NAMES.Add_HANDBOOK_PROVIDER, {
        onSubmit: (body) => this.onUpdateSubmit(row.provider_id, body),
        title: 'Изменить поставщика',
        body: row
      });
    },
    async onAddSubmit(body) {
      const res = await addHandbookProvider(body)
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
      this.closeModal();
    },
    async onUpdateSubmit(provider_id, body) {
      const res = await updateHandbookProvider(provider_id, body)
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
      this.closeModal();
    },
    async onDeleteSubmit(provider_id) {
      this.loading = true
      const res = await deleteHandbookProvider(provider_id)
      this.loading = false
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
    },
    handleClickDoc(doc) {
      const url = `${FILE_URL}${doc.report_url}`
      window.open(url, "_blank")
    },
    async sendTo1CHandler(provider_id) {
      this.btnLoading = { ...this.btnLoading, [provider_id]: true };
      const response = await sendTo1C(provider_id);
      this.btnLoading = { ...this.btnLoading, [provider_id]: false };
      if (!response) return;
      const message = response.message || response.description || "Успешно отправлено в 1С";
      this.showSucceedSnackbar(message);
      await this.getData();
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    const { showModal, closeModal } = useAppStore();
    return { showSucceedSnackbar, showModal, closeModal };
  },
}
</script>

<style scoped>
.info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  font-size: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.info:hover {
  border-color: #d4d9df;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.name {
  font-weight: 600;
  font-size: 13px;
  color: #1976d2;
  margin-bottom: 2px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e9ecef;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #495057;
  line-height: 1.5;
}

.details>div {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.details strong {
  color: #6c757d;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  min-width: 65px;
}

.params-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 8px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.param-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 6px;
  background: white;
  border-radius: 3px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.param-item:hover {
  border-color: #dee2e6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.param-item.highlight {
  background: linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 100%);
  border-color: #bbdefb;
}

.param-label {
  font-size: 11px;
  font-weight: 500;
  color: #6c757d;
  white-space: nowrap;
}

.param-value {
  font-size: 12px;
  font-weight: 600;
  color: #1976d2;
  background: white;
  padding: 1px 6px;
  border-radius: 3px;
  border: 1px solid #bbdefb;
}

.providers-page__sbs-title {
  font-size: 12px;
  color: #ff9800;
}

.providers-page__tax-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.providers-page__tax-item {
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #1976d2;
  transition: all 0.2s ease;
}

.providers-page__tax-item:hover {
  background: #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.providers-page__tax-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.providers-page__tax-icon {
  color: #1976d2;
}

.providers-page__tax-value {
  font-size: 13px;
  font-weight: 500;
  color: #212529;
  line-height: 1.4;
  margin-bottom: 4px;
}

.providers-page__tax-guid {
  font-size: 10px;
  color: #6c757d;
  font-family: 'Courier New', monospace;
  background: white;
  padding: 2px 6px;
  border-radius: 3px;
  display: inline-block;
  margin-top: 2px;
}
</style>